export function popUp() {

    let $ = jQuery;
    $(document).on('click','#menu-item-590', function () {
       alert('You are now leaving the MGI North America website.');
    });
}



// WEBPACK FOOTER //
// ./assets/ts/src/helpers/popup.ts